<template>
    <PasswordRecoveryForm v-if="!emailSubmitted" @submitted="onSubmitted"/>
    <PasswordRecoveryConfirmation v-else :recoveryEmail="emailSubmitted" />
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import PasswordRecoveryForm from '../components/password-recovery/PasswordRecoveryForm.vue';
import PasswordRecoveryConfirmation from '../components/password-recovery/PasswordRecoveryConfirmation.vue';

@Component({ components: { PasswordRecoveryForm, PasswordRecoveryConfirmation } })
export default class PasswordRecoveryView extends Vue {

    emailSubmitted: string | null = null;

    onSubmitted(email: string): void {
        this.emailSubmitted = email;
    }

}
</script>
